<template>
	<personal-layout cur-menu="tradelistomni">
		<div class="right-box">
			<div class="top-box flex-row">
				<div>全渠道订单</div>
				<div class="top-box-r">
					<div class="search-box">
						<el-input clearable @clear="clearFn" placeholder="请输入内容" v-model="searchValue">
							<el-select v-model="selectSearchKey" slot="prepend" placeholder="请选择">
								<el-option label="商品名称" value="0"></el-option>
								<el-option label="手机号" value="1"></el-option>
								<el-option label="收件人" value="2"></el-option>
								<el-option label="订单编号" value="3"></el-option>
								<el-option label="原始单号" value="4"></el-option>
							</el-select>
							<el-button slot="append" type="danger" icon="el-icon-search" class="size18" @click="search">
							</el-button>
						</el-input>
						<div class="box-arrow" @click="showTimeFilter">
							筛选
							<i :class="isShowTimeFilter?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
						</div>
					</div>
					<div class="timefilter-box" v-if="isShowTimeFilter">
						<el-date-picker value-format="yyyy-MM-dd" placeholder="请选择下单时间(起始)" suffix-icon="el-icon-date" v-model="startFilterTime">
						</el-date-picker>
						<i class="el-icon-minus"></i>
						<el-date-picker value-format="yyyy-MM-dd" placeholder="请选择下单时间(结束)" suffix-icon="el-icon-date" v-model="endFilterTime">

						</el-date-picker>

					</div>
				</div>
			</div>
			<div :style="{height: screenHeight+ 'px'}" style="position: relative;" v-loading="!isLoaded">
				<el-tabs :stretch='true' class="tab-box" v-model="activeMenu" @tab-click="menuClick">
					<el-tab-pane v-for="(tabItem, tabIndex) in navList" :key="tabItem.name" :name="tabItem.name">
						<span slot="label">{{tabItem.text}}
							<el-badge :value="tabItem.count" v-show="tabItem.count>0 && (tabIndex == 1 || tabIndex == 2)">
							</el-badge>
						</span>

						<div v-if="isLoaded" class="list-box" infinite-scroll-container=".list-box" :style="{height: screenHeight+ 'px'}" v-infinite-scroll="loadTradeList" infinite-scroll-distance="600px" v-loading="loadingType == 'loading' && tradeList.length == 0" element-loading-text="加载中">
							<trade-item v-for="(item, index) in tradeList" :key="index" :tradeInfo="item" @detail="tradeDetail" @displayTrajectory="displayTrajectory" @lookLogistic="lookLogistic" :isShowTradeReceiver="isShowTradeReceiver" :isShowLogisticBtnInTradeList="isShowLogisticBtnInTradeList" :isOpenInvoice="isOpenInvoice" :isFromTradelistomni="true">
							</trade-item>
							<div class="load-tip" v-if="loadingType == 'loading' && tradeList.length > 0">
								正在加载更多</div>
							<div class="load-tip" v-else-if="loadingType == 'nomore'">没有更多数据</div>
						</div>
					</el-tab-pane>

				</el-tabs>
			</div>

		</div>

		<div class="dialogBox">
			<el-dialog class="detailDialog" title="查看轨迹" :visible.sync="dialogVisible" style="margin-left: 28%;width:880px;">
				<iframe :src="webviewSrc" style="border: none; width: 402px; height: 628px;"></iframe>
			</el-dialog>
		</div>

		<trade-logistic :isShow="showLogDialog" :tradeId="logisticInfo.tradeId" :tradeNo="logisticInfo.tradeNo" :logisticId="logisticInfo.logisticId" :logisticNo="logisticInfo.logisticNo" :mobile="logisticInfo.mobile" @close="closeLogDialog"></trade-logistic>
	</personal-layout>
</template>

<script>
	import personalLayout from '../../components/mine/PersonalLayout.vue'
	import tradeItem from '../../components/trade/TradeItem.vue'
	import tradeAgainDialog from '../../components/trade/TradeAgainDialog.vue';
	import tradeLogistic from '../../components/trade/TradeLogistic.vue'
	import tradeUtils from '../../utils/api-utils/api-trade.js';
	import exportUtils from '../../utils/api-utils/api-export.js';
	import commonUtils from '../../utils/common-utlis.js';
	import goodsUtils from '../../utils/api-utils/api-goods.js';
	import refundApi from '../../utils/api-utils/api-refund.js';
	import { constant } from '../../config.js';
	import { getTimelinesData, setTimelinesData } from '../../utils/api-utils/data-refresh.js';
	import { getParam } from '../../utils/api-utils/api-params.js';
	import { getCustomerInfo, getCrmCustomerList } from '../../utils/api-utils/api-customer.js';
	import { getPresaleInfoByGoodsId } from '../../utils/api-utils/api-activity.js';
	export default {
		name: 'tradelist',
		components: {
			personalLayout,
			tradeItem,
			tradeAgainDialog,
			tradeLogistic,
		},
		data() {
			return {
				isShowLogin: false,
				activeMenu: '',
				tabCurrentIndex: 0,
				isExported: false,
				screenHeight: 650,
				dialogVisible: false,
				webviewSrc: "",
				navList: [{
						text: '全  部',
						name: 'allTrade',
					},
					{
						text: '待收货',
						name: 'waitTrade',
					},
					{
						text: '已完成',
						name: 'finishedTrade',
					}
				],
				loadingType: 'more',
				tradeList: [],
				pageIndex: 0,
				pageSize: 15,
				searchValue: "",
				selectSearchKey: "0",
				initData: false,
				isShowTradeReceiver: false, // 是否开启收件人
				isShowTimeFilter: false, //是否展示是时间筛选
				startFilterTime: "", //建单筛选开始时间 
				endFilterTime: "", //建单筛选结束时间
				listHander: { // 表头
					tradeTime: '下单时间',
					tradeNo: "原始单号",
					tradeStatus: "订单状态",
					payTotal: "应收合计",
					goodsSummary: "货品摘要",
					sendTo: "收货人",
					tel: "收货电话",
					address: "收货地址",
					customerRemark: "客户备注"
				},
				showLogDialog: false,
				logisticInfo: {},
				isOpenInvoice: false, // 是否允许自助开票
				allChannelTradeReqParams: {}, // 全渠道订单所需的请求参数 
				isLoaded: false,
				tradeStatusMap: {
					0: "未转入销售单的网店订单",
					1000: "排队处理中-请等待",
					1010: "待审核",
					1020: "审核中",
					1030: "预售",
					1050: "待复核",
					1051: "复核中",
					2000: "备货等待",
					2010: "备货等待-等补货",
					2020: "服务等待",
					2030: "备货等待-等生产",
					2040: "采购等待",
					3010: "虚拟发货",
					4110: "待发货-待递交",
					4111: "待发货-递交中",
					4112: "待发货-已递交",
					4113: "待发货-递交失败",
					4114: "待发货-生产中",
					4121: "待发货-取消中",
					4122: "待发货-已取消",
					4123: "待发货-取消失败",
					4130: "部分发货",
					4040: "代销发货-待递交",
					4041: "代销发货-已递交",
					4042: "代销发货-待采购",
					4050: "门店发货-待递交",
					4051: "门店发货-已递交",
					4052: "门店发货-递交失败",
					5010: "已取消",
					5020: "已取消-被合并",
					5030: "已取消-被拆分",
					6000: "发货在途",
					9090: "已完成"
				}, // 订单状态映射
			}
		},
		mounted() {
			this.initData = true;
			if (document.body.clientHeight < 850) {
				this.screenHeight = 500;
			}
			this._initData();
		},

		beforeRouteEnter(to, from, next) {
			//进入页面之前，判断是否是订单详情进入，是则不刷新
			if (from.name == 'tradedetailomni') {
				to.meta.refreshPage = false;
			} else {
				to.meta.refreshPage = true;
			}
			next();
		},
		//在页面离开时记录滚动位置
		beforeRouteLeave(to, from, next) {
			// 获取div内部滚动距离
			let scrollTop = document.getElementsByClassName('list-box')[this.tabCurrentIndex].scrollTop;
			localStorage.setItem('scrollTop_omni', scrollTop);
			next();
		},
		activated() {
			//来源不是订单确认，刷新数据
			if (this.$route.meta.refreshPage) {
				this.tabCurrentIndex = 0;
				this.loadingType = 'more';
				this.tradeList = [];
				this.pageIndex = 0;
				this.isLoaded = false;
				this._initData();
			} else {
				try {
					let scrollTop = localStorage.getItem('scrollTop_omni');
					localStorage.removeItem('scrollTop_omni');
					document.getElementsByClassName('list-box')[this.tabCurrentIndex].scrollTo(0, scrollTop);
				} catch (e) {}
			}
		},
		deactivated() {
			this.initData = false;
		},
		destroyed() {
			this.initData = false;
		},
		methods: {
			/**
			 * 初始化数据
			 */
			async _initData() {
				let that = this;
				that.tabCurrentIndex = that.$route.params.tabIndex || that.$route.meta.refreshTab;
				that.activeMenu = that.navList[that.tabCurrentIndex].name;
				that.customerId = localStorage.getItem("pc_customerId");

				// 提示登录
				if (!that.customerId) {
					that.$eventBus.$emit("showLoginDialog", true, false); //显示登录弹窗,不可关闭
					return
				}

				that.customerInfo = await getCustomerInfo()

				let paramlist = await getParam('channelAnotherNameList,bindSaleChannelId,isShowTradeReceiver,isShowLogisticBtnInTradeList,isOpenInvoice')
				that.isShowTradeReceiver = paramlist.isShowTradeReceiver == "1";
				that.isShowLogisticBtnInTradeList = paramlist.isShowLogisticBtnInTradeList == "1";
				that.isOpenInvoice = paramlist.isOpenInvoice == "1";
				that.channelAnotherNameList = JSON.parse(paramlist.channelAnotherNameList || "[]")

				// 加载全渠道订单所需的请求参数
				await that.loadAllChannelTradeReqParams();

				this.isLoaded = true

				// 加载订单列表
				that.loadTradeList()
			},

			/**
			 * 切换tab
			 */
			menuClick(tab, event) {
				this.tabCurrentIndex = parseInt(tab.index);
				this.loadingType = 'more';
				this.tradeList = [];
				this.pageIndex = 0;

				this.loadTradeList()
			},

			/**
			 * 加载全渠道订单所需的请求参数（缓存机制）
			 */
			async loadAllChannelTradeReqParams() {
				// 获取当前登录用户的Id和手机号
				let {
					customerId,
					phone: tel
				} = this.customerInfo;

				// 优先读取缓存中存储的信息（以下数据搜索都很慢，需要添加缓存机制）
				let allChannelTradeReqParams = getTimelinesData(constant.DATA_KEY_ALL_CHANNEL_TRADE_REQ_PARAMS);
				// 存在缓存数据且手机号没变，则直接使用缓存数据
				if (allChannelTradeReqParams && allChannelTradeReqParams.customerPhone == tel) {
					this.allChannelTradeReqParams = allChannelTradeReqParams;
					return;
				}

				try {
					// 显示加载中
					// showLoading("用户数据加载中");

					// 记录原始手机号到请求参数
					this.allChannelTradeReqParams.customerPhone = tel;

					// 获取当前用户手机号对应的加密手机号
					let resPhone = await tradeUtils.getEncryptedPhoneInfo(tel);
					if (resPhone) {
						// 记录加密手机号到请求参数
						this.allChannelTradeReqParams.encryptedPhoneList = resPhone.mobilesAll || [];
						this.allChannelTradeReqParams.tbEncryptedPhoneList = resPhone.sourceTradeNosFromTbMobile || [];
					}

					// 获取手机号对应的所有客户档案
					let crmCustomerList = await getCrmCustomerList({
						phone: tel
					});

					let customerIdList = [];
					// 获取手机号集合
					if (crmCustomerList && crmCustomerList.length > 0) {
						// 获取所有Id集合
						customerIdList = crmCustomerList.map(t => t.customerId) || [];
					}
					// 检测是否包含当前手机号
					if (!customerIdList.includes(customerId)) {
						customerIdList.push(customerId);
					}
					// 记录相关客户Id到请求参数
					this.allChannelTradeReqParams.customerIdList = customerIdList || [];

					// 获取需要过滤的订单标记（默认过滤售后单）
					this.allChannelTradeReqParams.notIncludeFlagId = await tradeUtils.getSearchOmsTradeListNotIncludeFlagId();

					// 保存到缓存
					setTimelinessData(DATA_KEY_ALL_CHANNEL_TRADE_REQ_PARAMS, this.allChannelTradeReqParams);
				} catch (e) {} finally {
					// 关闭加载中
					// hideLoading();
				}
			},

			/**
			 * 加载订单列表
			 */
			loadTradeList: commonUtils.debounce(async function() {
				if (this.loadingType == 'nomore') {
					return;
				}

				this.loadingType = 'loading';
				// 生成请求数据
				let reqParams = await this.__createRequestParams();

				// 获取原始订单列表
				let tradeRes = await tradeUtils.getAllChannelTradeList(reqParams);

				// 获取订单列表
				let omsTradeList = tradeRes.tradeOrderList || [];

				// 检测订单数据是否存在
				if (omsTradeList && omsTradeList.length == 0) {
					this.loadingType = 'nomore'
					return
				}

				// 补充订单状态
				await this.__completeTradeExtendedInfo(omsTradeList);

				// 处理订单展示数据
				this.__processTradeViewData(omsTradeList);


				this.loadingType = !(omsTradeList && omsTradeList.length >= this.pageSize) ? 'nomore' : 'more';
				this.tradeList = this.tradeList.concat(omsTradeList);
				this.pageIndex = this.pageIndex + 1;
			}, 400, false),

			/**
			 * 补充订单扩展信息（退款单状态等）
			 */
			async __completeTradeExtendedInfo(omsTradeList) {
				return new Promise(async (resolve, reject) => {
					// 获取吉客云订单编号
					let jackyunTradeNoList = omsTradeList.map(t => t.tradeNo);

					// 执行集合
					let promiseList = [
						// 获取退款单状态
						refundApi.getRefundStatusByJackyunTradeNo(jackyunTradeNoList),
					];

					// 等待所有接口执行完成
					Promise.all(promiseList).then((res) => {
						// 获取出返回数据
						let refundStatusList = res[0] || [];

						// 遍历订单，补充相关数据
						omsTradeList.forEach(trade => {
							trade.tradeStatusExplain = this.tradeStatusMap[trade.tradeStatus]
							// 补充退款单状态
							let curTradeRefundList = refundStatusList.filter(t => t.jackyunTradeNo == trade.tradeNo);
							// 处理退款单状态
							refundApi.processingTradeRefundStatus(curTradeRefundList, trade);
						});

						resolve();
					});
				});
			},

			/**
			 * 处理订单展示数据
			 * @param {*} omsTradeList 
			 */
			__processTradeViewData(omsTradeList) {
				// 订单数据处理
				omsTradeList.forEach(item => {
					// 处理货品数量
					item.tradeCount = parseInt(item.tradeCount) || 1;

					// 是否为权益券订单
					item.isMemberCouponTrade = !item.sourceTradeNo && item.sellerMemo && item.sellerMemo.startsWith('该订单为卡券兑换');

					// 判断是否为付费会员订单
					item.isMemberTrade = item.sourceTradeNo && item.sourceTradeNo.startsWith("HY");

					// 显示渠道别名
					let matchChannelAnotherNameInfo = this.channelAnotherNameList.find(t => item.shopId == t.channelId);
					item.shopName = matchChannelAnotherNameInfo && matchChannelAnotherNameInfo.channelAnotherName || item.shopName;

					//处理订单状态 如：待发货-已递交，只显示待发货
					try {
						// 代销发货=>待发货
						if (item.tradeStatusExplain == "代销发货") {
							item.tradeStatusExplain = "待发货";
						} else if (item.tradeStatus == 5020) {
							item.tradeStatusExplain = "原始单-被合并";
						} else if (item.tradeStatus == 5030) {
							item.tradeStatusExplain = "原始单-被拆分";
						} else {
							item.tradeStatusExplain = item.tradeStatusExplain.split('-')[0] || "";
						}
					} catch (e) {}

					// 标记订单是否取消
					item.isCancelled = item.tradeStatusExplain && item.tradeStatusExplain.includes("取消");

					// 商品名称处理
					if (item.goodslist) {
						try {
							// 如果是json传，直接反序列化，不是则拆分处理
							let goodsInfoList = item.goodslist.includes('{"') ? JSON.parse(item.goodslist).goodsInfoList : item.goodslist.split(',');
							//获取示例商品,格式：(1)商品名称[规格]
							item.goodsName = goodsInfoList[0] + (goodsInfoList.length > 1 ? '等' : '');
						} catch (e) {
							item.goodsName = item.goodslist;
						}
					}
					item.mainPic = 'http://jkyun--jmall.oss-cn-hangzhou.aliyuncs.com/jmc/appStatic/other/trade-logo.png'
					item.tradeOrder = item
				});
			},

			/**
			 * 生成请求数据
			 */
			async __createRequestParams() {
				// 公共请求参数（全渠道用户、过滤标签等，有缓存控制）
				let params1 = this.__getCommonSearchParams__();

				// 获取搜索框搜索的参数
				let params2 = await this.__getInputSearchParams__();

				// 获取时间筛选的参数
				let params3 = this.__getTimeSearchParams__();

				// 获取状态筛选的参数
				let params4 = this.__getStatusSearchParams__();

				// 获取翻页参数
				let params5 = this.__getPageSearchParams__();

				return {
					...params1,
					...params2,
					...params3,
					...params4,
					...params5
				};
			},

			/**
			 * 获取搜索的参数
			 */
			__getCommonSearchParams__() {
				// 搜索参数
				let allChannelTradeReqParams = this.allChannelTradeReqParams

				return {
					mobiles: allChannelTradeReqParams.encryptedPhoneList,
					sourceTradeNosFromTbMobile: allChannelTradeReqParams.tbEncryptedPhoneList,
					customerIds: allChannelTradeReqParams.customerIdList,
					notIncludeFlagId: allChannelTradeReqParams.notIncludeFlagId, // 过滤标签
				}
			},

			/**
			 * 获取搜索的参数
			 */
			async __getInputSearchParams__() {
				// 搜索参数
				let params = {};

				// 存在搜索内容则需要添加搜索项
				let searchValue = this.searchValue;
				if (!searchValue) {
					return params;
				}

				// 添加搜索内容
				switch (this.selectSearchKey) {
					// 货品摘要
					case '0':
						params.goodsName = searchValue;
						break;
						// 手机号
					case '1':
						// 获取当前用户手机号对应的加密手机号
						let resPhone = await tradeUtils.getEncryptedPhoneInfo(searchValue);
						if (resPhone) {
							// 记录加密手机号到请求参数
							params.cryptMobiles = resPhone.mobilesAll || [];
						} else {
							params.cryptMobiles = [searchValue];
						}
						break;
						// 收件人
					case '2':
						params.receiverName = searchValue;
						break;
						// 订单编号
					case '3':
						params.tradeNo = searchValue;
						break;
						// 原始单号
					case '4':
						params.sourceTradeNo = searchValue;
						break;
				}

				return params;
			},

			/**
			 * 获取搜索的参数
			 */
			__getTimeSearchParams__() {
				// 建单时间筛选
				return {
					tradeTimeBegin: this.startFilterTime ? `${this.startFilterTime} 00:00:00` : "",
					tradeTimeEnd: this.endFilterTime ? `${this.endFilterTime} 23:59:59` : ""
				};
			},

			/**
			 * 获取搜索的参数
			 */
			__getStatusSearchParams__() {
				// 全部订单
				if (this.navList[this.tabCurrentIndex].name == 'allTrade') {
					return {};
				}
				// 待收货
				if (this.navList[this.tabCurrentIndex].name == 'waitTrade') {
					return {
						isSelectPostWait: 1
					};
				}
				// 已完成
				if (this.navList[this.tabCurrentIndex].name == 'finishedTrade') {
					return {
						isSelectFinish: 1
					};
				}
			},

			/**
			 * 获取翻页参数
			 */
			__getPageSearchParams__() {
				return {
					pageIndex: this.pageIndex, // 页码
					pageSize: this.pageSize, // 单页数量
					sortOrder: "DESC"
				};
			},


			/**
			 * 点击搜索
			 */
			search() {
				this.$message.closeAll();
				if (this.searchValue && !this.selectSearchKey) {
					this.$message.error("请选择搜索类型");
					return;
				}
				if (this.navList[this.tabCurrentIndex].loadingType === 'loading') {
					this.$message.error("列表正在加载中，请稍候点击");
					return;
				}
				if ((this.startFilterTime && this.endFilterTime) && this.startFilterTime > this.endFilterTime) {
					this.$message.error("起始时间不得大于终止时间");
					return;
				}

				this.loadingType = 'more';
				this.tradeList = [];
				this.pageIndex = 0;

				this.loadTradeList()
			},

			/**
			 * 展示物流
			 */
			displayTrajectory(res) {
				this.dialogVisible = res.dialogVisible;
				this.webviewSrc = res.webviewSrc;
			},


			/**
			 * 订单详情
			 */
			async tradeDetail(item) {
				this.$router.push({
					name: 'tradedetailomni',
					query: {
						no: item.tradeNo
					}
				});

			},

			/**
			 * 获取吉客云订单总数s
			 */
			async _getOmsTradeCount(tradeStatus, isNoSet) {
				let jackyunTradeCount = await tradeUtils.getPersonalOmsTradeCount(tradeStatus)

				// 是否需要设置数量
				if (isNoSet) {
					return jackyunTradeCount
				}

				this.navList[2].count = jackyunTradeCount;
				this.navList[2].countLoaded = true;
			},



			/**
			 * 清空
			 */
			clearFn() {
				this.searchValue = "";
				this.selectSearchKey = "";
			},

			/**
			 * 时间统一转为斜杠
			 */
			convertTime(time) {
				return time.replace(/-/g, '/');
			},

			/**
			 * 解析手机号（去除加密前后缀）
			 * @param {Object} tel
			 */
			parseTel(tel) {
				if (!tel) {
					return "";
				}

				if (!tel.includes('differ')) {
					return tel;
				}
				try {
					return tel.substring(tel.indexOf('~*') + 1, tel.indexOf('~/diffe'));
				} catch (e) {
					return tel;
				}
			},

			/**
			 * 模糊手机号
			 * @param {Object} tel
			 */
			getFuzzyTel(tel) {
				try {
					return `*******${tel.substr(tel.length-4)}`;
				} catch (e) {
					return tel;
				}
			},

			/**
			 * 展示时间筛选
			 */
			showTimeFilter() {
				this.isShowTimeFilter = !this.isShowTimeFilter;
			},

			/**
			 * 拼接吉商城完整地址
			 * @param {Object} country
			 * @param {Object} province
			 * @param {Object} city
			 * @param {Object} district
			 * @param {Object} town
			 * @param {Object} address
			 */
			getJmallFullAddress(country, province, city, district, town, address) {
				if (!country || country == "中国") {
					return `${province||''} ${city||''} ${district||''} ${address||''}`;
				} else {
					return `${country||''} ${address||''}`;
				}
			},

			/**
			 * 关闭查看物流
			 */
			closeLogDialog() {
				this.showLogDialog = false;
			},

			/**
			 * 查看物流
			 */
			lookLogistic(res) {
				this.showLogDialog = true;
				let tradeInfo = res.tradeInfo;
				this.logisticInfo = {
					tradeId: tradeInfo.tradeId,
					tradeNo: tradeInfo.tradeNo,
					logisticId: tradeInfo.tradeOrder.logisticId,
					logisticNo: tradeInfo.tradeOrder.mainPostid,
					mobile: tradeInfo.tradeOrderReceiver.mobile,
				}
			},

		}
	}
</script>

<style scoped="scoped">
	.right-box {
		background-color: #fff;
		padding: 30px !important;
		font-size: 18px;
		height: calc(100% - 60px);
	}

	.top-box {
		align-items: center;
		justify-content: space-between;
		margin-bottom: 30px;
	}

	.size18 {
		font-size: 18px !important;
	}

	.tab-box {
		margin-left: 30px;
	}

	.list-box {
		height: 650px;
		overflow: auto;
	}

	.list-box-small {
		height: 600px;
		overflow: auto;
	}


	/deep/.el-input-group__prepend {
		width: 70px;
	}

	/deep/.el-tabs__item {
		font-size: 17px;
		color: #aeaeae;
		padding: 0 40px;
	}

	/deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
		padding-left: 40px;
	}

	/deep/.el-tabs__item:hover,
	/deep/.el-tabs__item.is-active {
		color: #000;
	}

	/deep/.el-tabs__active-bar {
		background-color: #000 !important;
	}

	/deep/.el-badge__content.is-fixed {
		top: 10px;
		right: -5px;
	}

	/deep/.el-badge__content {
		background-color: #000 !important;
	}

	.load-tip {
		color: #999;
		font-size: 14px;
		margin-top: 20px;
		text-align: center;
	}

	.search-box /deep/.el-input-group__append {
		background-color: #f56c6b;
		border-color: #f56c6b;
		color: #fff;
		font-size: 20px;
	}




	.export-button {
		position: absolute;
		top: 0px;
		right: 0px;
		line-height: 8px;
	}

	.content-box {
		padding: 30px;
		height: calc(100% - 240px);
	}

	.detailDialog /deep/ .el-dialog {
		overflow: hidden;
	}

	.dialogBox /deep/ .el-dialog__wrapper {
		overflow: hidden !important;
	}

	.detailDialog /deep/ .el-dialog__body {
		width: 102%;
		padding-top: 0 !important;
		overflow-y: auto !important;
	}

	.top-box-r {
		width: 565px;
	}

	.search-box {
		display: flex;
	}

	.box-arrow {
		margin-left: 20px;
		display: flex;
		font-size: 16px;
		width: 88px;
		line-height: 40px;
	}

	.el-icon-arrow-down {
		font-size: 24px;
		line-height: 40px;
		margin-left: 10px;
	}

	.el-icon-arrow-up {
		font-size: 24px;
		line-height: 36px;
		margin-left: 10px;
	}

	.timefilter-box {
		margin-top: 10px;
		display: flex;
		padding-right: 92px;
	}

	.el-icon-minus {
		margin: 0 10px;
		line-height: 40px;
	}
</style>